import { Grid, Typography, MenuItem } from '@mui/material'
import { IconContainer } from 'components/atoms/Icons'
import RowStack from 'components/atoms/container/RowStack'
import FormInputBox from 'components/atoms/input/FormInputBox'
import { StyledSelect } from 'components/atoms/input/StyledInputs'
import colors from 'styles/colors'
import NotificationSnackBar from 'components/molecules/notificationOverlay/NotificationSnackBar'
import { useTranslation } from 'react-i18next'

const boxShadow = '1px 1px 10px 0px rgba(160, 160, 160, 0.05)'

export const ProfileRow = ({ icon, label, children }) => {
  return (
    <Grid container spacing={6} size={12}>
      <Grid size={3}>
        <RowStack spacing={4} height='100%'>
          <IconContainer icon={icon} size={24} />
          <Typography variant='body1KindaSmall'>{label}:</Typography>
        </RowStack>
      </Grid>
      <Grid size={9}>{children}</Grid>
    </Grid>
  )
}

export const ProfileTextInput = ({
  formik,
  attributeName,
  placeholder,
  ...otherProps
}) => {
  return (
    <FormInputBox
      type='text'
      placeholder={placeholder}
      formik={formik}
      attributeName={attributeName}
      sx={{
        width: '100%',
        boxShadow,
        '& .MuiInputBase-root': {
          minWidth: 'auto',
          height: 44,
          paddingX: 8,
          paddingY: 6,
          '&.Mui-disabled': {
            backgroundColor: colors.Grey50,
            '& .MuiOutlinedInput-notchedOutline': {
              border: 0
            }
          }
        },
        '& .MuiInputBase-input': {
          padding: 0,
          '&.Mui-disabled': {
            color: colors.MidnightTeal300,
            WebkitTextFillColor: colors.MidnightTeal300
          }
        }
      }}
      {...otherProps}
    />
  )
}

export const ProfileOnboardingQuestionSelect = ({
  options,
  onChange,
  value,
  sx = {},
  placeholder = '',
  ...otherProps
}) => {
  return (
    <StyledSelect
      sx={{
        width: '100%',
        minHeight: 44,
        padding: '10px 12px 10px 16px',
        boxShadow,
        '& .MuiSelect-select': { padding: 0 },
        '& .MuiSvgIcon-root': { right: 0 },
        ...sx
      }}
      displayEmpty
      value={value}
      onChange={onChange}
      {...otherProps}>
      {placeholder && (
        <MenuItem value='' disabled>
          <Typography
            variant='body1KindaSmall'
            color={colors.Grey300}
            opacity={0.42}>
            {placeholder}
          </Typography>
        </MenuItem>
      )}
      {options?.map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </StyledSelect>
  )
}

export const ProfileSnackBar = ({
  open,
  setOpen,
  requestSuccess,
  ...otherProps
}) => {
  const { t } = useTranslation()
  return (
    <NotificationSnackBar
      open={open}
      setOpen={setOpen}
      autoHideDuration={4000}
      successText={t('profile.profileUpdated')}
      errorText={t('profile.profileNotUpdated')}
      error={!requestSuccess}
      success={requestSuccess}
      {...otherProps}
    />
  )
}
